module.exports = __webpack_public_path__ + "static/media/night-cloud-rain-lightning-icon.5c5b4032.svg";